import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { formatDate } from '@angular/common';
import { Image } from 'primeng/image';

@Component({
  selector: 'app-tickets-list',
  templateUrl: './tickets-list.component.html',
  styleUrls: ['./tickets-list.component.css']
})
export class TicketsListComponent implements OnInit {
  i: any;
  deleteId: any;
  ticketcontroller: any = [];
  TicketTask: any = [];
  users: any = [];
  TicketTaskdata: any = [];
  TicketData: any = [];
  tagUsersdropdownList = [];
  tagUsersselectedItems: any = [];
  tagUsersdropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  userIdList = [];
  taskMasters: any = []
  status = "OPEN"
  addTaskButton = true
  ctid: any = ""


  pageNumber1: number = 0;
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  formSubmit = false;

  showFilter: boolean = false;

  filterDateChecked = false
  startDate = ""
  endDate = ""
  customerPhoneNoChecked = false
  customerPhoneNo = ""
  filterByTicketIdChecked = false
  filterByTicketId = ""
  filterByTechnicianChecked = false
  filterByTechnician = ""
  filterByticketPriorityChecked = false
  filterByticketPriority = ""

  filterByServiceTypeChecked = false
  filterByServiceType = ""

  filterByticketCompletedAndDatesChecked = false
  filterByticketCompletedAndDates = ""

  filterByticketClosedAndDatesChecked = false
  filterByticketClosedAndDates = ""

  filterStatusAndDateChecked = false
  filterStatusDate = ""
  statusStartDate = ""
  statusEndDate = ""

  filteredData: any = []
  tnotes = ""
  priority_dropdown_toggle: boolean = false
  ticketDetails_toggle: boolean = false
  taskDetails_toggle: boolean = false

  updateDetails: any = ""
  addNoteShow: any = false
  largeImage: any = ""

  filterStartDate: any

  isLoading: any = false;

  serviceData: any = []

  ProductParams: any = []
  keyValueList: any = []
  paramData: any = []
  latitude: any;
  longitude: any;
  url1: any = '';
  documents: any = []

  prevTicketsList: any = []
  noteImageView: any = ""

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService, private router: Router) { }

  form: any | FormGroup
  customerForm: any | FormGroup
  Taskform: any | FormGroup
  modelSubtitle = false
  IDs: any = []
  data: any = []
  fileType: any;
  file = '';
  images: any = [];
  videos: any = [];
  audios: any = [];
  description = "";
  typeId = "";
  heading = "";
  details = "";
  source = "";
  customerID = "";
  customerType = ""
  searchFilter = ''
  newTicketCount = 0
  ticketId = 0
  ticketDesc = ""
  taskId = ""
  note = ""
  ticketStatus = ""
  ticketClosingOtp = ""
  usersList: any = []
  assignInput = ""
  addClassType = ""
  TaskNameAndDescription: any = []
  cid: any
  usersWithoutCustomers: any = []
  toDayDate: any = ""

  excelData: any = []
  downloadData: any = []

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }


  NoteImage: any = ""

  ngOnInit(): void {



    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    if (sessionStorage.getItem('dashboard-status') && sessionStorage.getItem('dashboard-status') != null && sessionStorage.getItem('dashboard-status') != undefined) {
      this.status = String(sessionStorage.getItem('dashboard-status'))
    }
    this.toDayDate = new Date().getTime()
    this.cid = sessionStorage.getItem('cid')
    this.getUsers();
    this.getUsersWithoutCustomers()
    this.getAllTaskNameAndDescription()
    this.generic_service.gettypeids().subscribe((res: any) => {
      console.log(res)
      this.IDs = res.response
    })

    this.getTicketcontroller()
    this.getAllServices()
    this.getCustomerParams()
    this.getParamByType()
    this.form = this.fb.group({
      description: [''],
      typeId: ['', [Validators.required]],
      heading: ['', [Validators.required]],
      details: ['', [Validators.required]],
      source: [''],
      customerID: ['', [Validators.required]],
      customerType: ['', [Validators.required]],
      customerName: ['', [Validators.required]],
      customerPhNo: ['', [Validators.required]],
      assignedToUserName: ['']
    });


    this.customerForm = this.fb.group({
      name: [''],
      description: [''],
      address: [''],
      mobileNo1: [''],
      mobileNo2: [''],
      emailId: [''],
      image: [''],
      serviceName: [''],
      customerParamEntityList: this.fb.array([]),
    })

    this.Taskform = this.fb.group({
      name: [''],
      description: [''],
      assignedTo: [''],
      tagUserIds: [''],
      taskExpStartDate: [''],
      taskExpEndDate: [''],
    });

    if (sessionStorage.getItem('view_ticketId') && sessionStorage.getItem('view_ticketId') != null && sessionStorage.getItem('view_ticketId') != undefined) {
      this.getTicketTaskByID(sessionStorage.getItem('view_ticketId'))
      document.getElementById("view-ticket-button")?.click()
    }

  }

  toggleFilter() {
    this.showFilter = !this.showFilter
  }

  getUsersWithoutCustomers() {
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        console.log(res);
        this.usersWithoutCustomers = res.response;
      }
    )
  }

  getAllServices() {
    this.generic_service.getAllServices().subscribe(
      (response: any) => {
        this.serviceData = response.response;
        console.log(response)
      }
    )
  }

  onTableDataChange(event: any) {

    this.pageNumber = event - 1;
    this.pageNumber1 = event;
    this.getTicketcontroller();

  }

  ngOnDestroy() {
    console.log("ngOnDestroy")
    sessionStorage.removeItem('view_ticketId')
    sessionStorage.removeItem('dashboard-status')
  }

  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }



  Ticketid(id: any, details: any, name: any) {
    this.ticketId = id
    this.Taskform.get('description').setValue(details);
    this.Taskform.get('name').setValue(name);
    console.log(this.ticketId)
  }

  addTicketTask() {
    this.addTaskButton = false
    let tagUserIds = [];
    for (let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }

    let body = {
      "ticketId": this.ticketId,
      "taskList": [
        {
          "version": 0,
          "isActive": true,
          "description": String(this.Taskform.get('description').value),
          "taskRegType": "",
          "taskRegId": "",
          "taskSINumber": 0,
          "taskListingNumber": 0,
          "assignedTo": String(this.Taskform.get('assignedTo').value),
          "taskExpStartDate": new Date(this.Taskform.get('taskExpStartDate').value).getTime(),
          "taskExpEndDate": new Date(this.Taskform.get('taskExpEndDate').value).getTime(),
          "taskActStartDate": 0,
          "taskActEndDate": 0,
          "taskExpDuration": 0,
          "taskActDuration": 0,
          "status": [
            {
              "note": "",
              "taskStatus": "NEW",
              "updatedDate": 0
            }
          ],
          "completedPercentage": 0,
          "notes": "",
          "audio": this.audios,
          "video": this.videos,
          "image": this.images,
          "tagUserIds": tagUserIds,
          "name": String(this.Taskform.get('name').value),
          "cid": this.cid
        }
      ]
    }
    console.log(body)
    this.generic_service.addTicketTask(body).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllTicketTask()
        this.toastr.success(response.message);
        this.cancelModel()
        this.clearForm()
        this.addTaskButton = true
      }, (err: any) => {
        console.log(err)
        this.toastr.error(err.errors[0].description);
        this.addTaskButton = true
      }
    )


  }

  getAllTicketTask() {
    this.generic_service.getAllTicketTask().subscribe(
      (response: any) => {
        this.TicketTask = response.taskList;
        console.log(response)
      }
    )
  }

  nextTicketId: any = ""
  prevTicketId: any = ""

  prevTicket() {
    this.getTicketTaskByID(this.prevTicketId)
  }

  nextTicket() {
    this.getTicketTaskByID(this.nextTicketId)

  }

  getTicketTaskByID(id: any) {
    console.log(id)
    this.ticketId = id
    this.prevTicketsList = []
    // this.getSingleTicket(id)
    console.log(this.data)
    console.log(this.data.length)

    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].ticket.ticketId == id) {
        if (this.data[i + 1]) {
          this.nextTicketId = this.data[i + 1].ticket.ticketId
        } else {
          this.nextTicketId = ""
        }
        if (this.data[i - 1]) {
          this.prevTicketId = this.data[i - 1].ticket.ticketId
        } else {
          this.prevTicketId = ""
        }
      }

    }


    console.log(this.prevTicket)
    console.log(this.nextTicket)


    this.getAllTaskMasters()
    this.TicketData = []
    this.generic_service.getTicketTaskByID(id).subscribe(
      (res: any) => {

        console.log(res)


        this.customerForm.patchValue({
          name: res.response.ticket.customerName,
          address: res.response.ticket.customerAddress,
          mobileNo1: res.response.ticket.customerPhNo
        })

        this.getAllTicketsByCustomerPhoneNo1(res.response.ticket.customerPhNo, 0, 10)

        for (let i = 0; res.response.taskList.length > i; i++) {
          res.response.taskList[i].eDescription = res.response.taskList[i].description
          res.response.taskList[i].edit = false
        }
        this.TicketTaskdata = res.response.taskList;
        this.TicketData.push(res.response.ticket);
        this.updateDetails = res.response.ticket.details

        let arr: any = [];
        arr.push(Number(sessionStorage.getItem('userId')))
        let arr1: any = [];
        for (let i = 0; i < res.response.taskList.length; i++) {
          if (res.response.taskList[i].assignedTo != null && res.response.taskList[i].assignedTo != 0) {
            arr1.push(res.response.taskList[i].assignedTo)
          }
          if (res.response.taskList[i].tagUsers.length != 0) {
            for (let j = 0; j < res.response.taskList[i].tagUsers.length; j++) {
              arr.push(res.response.taskList[i].tagUsers[j].userid)
            }
          }
        }
        let arr3 = arr.concat(arr1)
        this.userIdList = arr3
        this.userIdList = this.userIdList.filter((item, index) => this.userIdList.indexOf(item) === index);

      },
      (err: any) => {
        console.log(err)
        this.TicketTaskdata = []
      }
    )
  }

  getUsers() {
    this.generic_service.getUsers().subscribe(
      (res: any) => {
        this.users = res.response;
        this.usersList = res.response;
        this.tagUsersdropdownList = res.response
        console.log(res);
      }
    )
  }


  cancelModel() {
    sessionStorage.removeItem('view_ticketId')
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton3")?.click()
    document.getElementById("closeModalButton67")?.click()
    document.getElementById("closeModalButton12")?.click()
    document.getElementById("closeModalButton6")?.click()
    document.getElementById("closeModalButton7")?.click()
  }

  getTicketcontroller() {
    this.ticketByStatus()
  }

  editskill() {

    this.data[this.i].description = this.description
    this.data[this.i].typeId = this.typeId
    this.data[this.i].heading = this.heading
    this.data[this.i].details = this.details
    this.data[this.i].source = this.source
    this.data[this.i].customerID = this.customerID
    this.data[this.i].customerType = this.customerType
    this.close()
  }
  open() {
    this.modelSubtitle = true;
  }
  close() {
    this.modelSubtitle = false;
    this.description = ""
    this.typeId = ""
    this.heading = ""
    this.details = " "
    this.source = ""
    this.customerID = ""
    this.customerType = ""
  }

  edit(i: any) {
    this.open();
    this.description = this.data[i].description;
    this.typeId = this.data[i].typeId;
    this.heading = this.data[i].heading;
    this.details = this.data[i].details;
    this.source = this.data[i].source;
    this.customerID = this.data[i].customerID;
    this.customerType = this.data[i].customerType;
  }

  delTicketController() {
    this.generic_service.delTicketcontroller(this.deleteId).subscribe(
      (res: any) => {
        console.log(res);
        this.toastr.success(res.message);
        this.getTicketcontroller()
        this.cancelModel();
      }, err => {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  del(id: any) {
    this.deleteId = id
  }

  getSingleTicket(id: any) {
    console.log(id)
    this.TicketData = []
    this.generic_service.getSingleTicket(id).subscribe(
      (res: any) => {
        console.log(res)
        this.TicketData = [];
        this.TicketData.push(res.response.ticket);
      }
    )
  }

  onSelectFile(event: any) {
    if (event.target.files) {
      console.log(event.target.files[0].type)
      console.log(event.target.files[0])
      if (event.target.files[0].type == "image/jpeg" || event.target.files[0].type == "image/png" || event.target.files[0].type == "image/png") {
        console.log('image')
        this.fileType = 'image'
      } else if (event.target.files[0].type == "video/mp4") {
        console.log('video')
        this.fileType = 'video'
      } else if (event.target.files[0].type == "audio/mpeg") {
        console.log('audio')
        this.fileType = 'audio'
      }
      var reader = new FileReader;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (e: any) => {
        this.file = e.target.result;
        if (this.fileType == 'image') {
          this.images.push(this.file)
        }
        if (this.fileType == 'video') {
          this.videos.push(this.file)
        }
        if (this.fileType == 'audio') {
          let file = URL.createObjectURL(event.target.files[0])
          this.audios.push(file)
        }
      }
    }
  }

  addImageBtn() {
    document.getElementById("add-image-btn")?.click()
  }

  addVideoBtn() {
    document.getElementById("add-video-btn")?.click()
  }

  addAudioBtn() {
    document.getElementById("add-audio-btn")?.click()
  }

  addc(i: any) {
    console.log(i)
    let list = document.getElementById(i)
    if (list?.classList.contains('dropdown-data')) {
      list.classList.remove('dropdown-data')
    } else {
      list?.classList.remove('dropdown-data-show')
      list?.classList.add('dropdown-data')
    }
  }

  activeStatus(id: string) {

  }

  insertConversation() {
    let body = {
      "version": 0,
      "isActive": true,
      "description": "string",
      "id": 0,
      "conversationType": "TICKET",
      "ticketTaskId": Number(this.ticketId),
      "userIdList": this.userIdList,
      "remarks": "string",
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.insertConversation(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success(response.message)
        this.cancelModel();
        this.router.navigateByUrl('/admin/create-user')
      },
      (err: any) => {
        console.log(err)
        this.cancelModel();
        this.toastr.error(err.error.errors[0].description)
        this.router.navigateByUrl('/admin/create-user')

      }
    )
  }

  remoates() {
    var array = this.userIdList;
    return array.filter((item, index) => array.indexOf(item) === index);
  }

  clearForm() {
    this.tagUsersselectedItems = []
    this.images = [];
    this.videos = [];
    this.audios = [];
    this.form.reset()
  }

  noteDropdown() {
    this.addNoteShow = !this.addNoteShow
    this.tnotes = ""
    this.NoteImage = ""
    let list = document.getElementById('dropN')
    if (list?.classList.contains('status-dropdown-show')) {
      list.classList.remove('status-dropdown-show');
    } else {
      list?.classList.add('status-dropdown-show')
    }
  }

  statusDropdown() {
    let list = document.getElementById('dropS')
    if (list?.classList.contains('status-dropdown-show')) {
      list.classList.remove('status-dropdown-show');
    } else {
      list?.classList.add('status-dropdown-show')
    }
  }

  reopenTicket(ticketId: any) {
    let body = {
      "note": "Re-opened the ticket",
      "ticketStatus": "OPEN",
      "updatedDate": 0
    }
    this.generic_service.updateTicketStatus(ticketId, body).subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        this.getTicketTaskByID(ticketId)
        this.statusDropdown()
        this.getTicketcontroller()
        console.log(response)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  updateTicketStatus(ticketId: any) {
    let body = {
      "note": String(this.note),
      "ticketStatus": String(this.ticketStatus),
      "updatedDate": 0,
      "images": [],
      "audios": [],
      "videos": [],
      "ticketClosingOtp": this.ticketClosingOtp
    }
    this.generic_service.updateTicketStatus(ticketId, body).subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        this.getTicketTaskByID(ticketId)
        this.statusDropdown()
        this.getTicketcontroller()
        console.log(response)
        this.ticketClosingOtp = ""
        this.ticketStatus = ""
        this.note = ""
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  msg91WhatsappSendTicketConversation() {
    let body = {
      "ticketId": Number(this.ticketId),
      "cid": Number(sessionStorage.getItem('cid')),
      "message": this.tnotes,
    }
    this.generic_service.msg91WhatsappSendTicketConversation(body).subscribe(
      (response: any) => {
        console.log(response)
      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  addNote() {
    let body =
    {
      "ticketId": Number(this.ticketId),
      "cid": Number(sessionStorage.getItem('cid')),
      "tNotes": {
        "slNo": 0,
        "note": this.tnotes,
        "userId": 0,
        "userName": "",
        "img": this.NoteImage,
        "video": "",
        "date": 0
      }
    }
    this.generic_service.updateTicketNotes(body).subscribe(
      (response: any) => {
        if (this.TicketData[0].source == 'whatsapp') {
          this.msg91WhatsappSendTicketConversation()
        }
        this.toastr.success(response.message)
        this.getTicketTaskByID(this.ticketId)
        this.noteDropdown()
        this.getTicketcontroller()
        this.tnotes = ""
        this.NoteImage = ""
        console.log(response)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }


  AssignToUser(ticketId: any, userId: any, ticketStatus: any, name: string) {
    let note = "";
    if (ticketStatus == "REASSIGNED") {
      note = "Ticket REASSIGNED to " + name;
    }
    if (ticketStatus == "ASSIGNED") {
      note = "Ticket ASSIGNED to " + name;
    }
    let body = {
      "ticketId": Number(ticketId),
      "userId": Number(userId),
      "ticketStatusDTO": {
        "note": String(note),
        "ticketStatus": "OPEN",
        "updatedDate": 0
      }
    }
    console.log(body)
    this.generic_service.ticketAssignToUser(body).subscribe(
      (response: any) => {
        console.log(response);
        this.getTicketTaskByID(ticketId)
        this.addClass('assignedTo')
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  addClass(value: any) {
    console.log(value)
    if (this.addClassType == '') {
      let list = document.getElementById('assign-and-tag-data')
      if (list?.classList.contains('assign-show')) {
        list.classList.remove('assign-show')
        this.addClassType = ''
      } else {
        list?.classList.add('assign-show')
        this.addClassType = value
      }
    } else {
      if (this.addClassType == value) {
        let list = document.getElementById('assign-and-tag-data')
        if (list?.classList.contains('assign-show')) {
          list.classList.remove('assign-show')
          this.addClassType = ''
        } else {
          list?.classList.add('assign-show')
          this.addClassType = value
        }
      } else {
        this.addClassType = value
      }
    }
  }

  getAllTaskMasters() {
    this.generic_service.getAllTaskMaster().subscribe(
      (response: any) => {
        console.log(response)
        this.taskMasters = response.response
      }
    )
  }

  getAllTaskNameAndDescription() {
    this.generic_service.getAllTaskNameAndDescription().subscribe(
      (response: any) => {
        console.log(response)
        this.TaskNameAndDescription = response.response
      }
    )
  }

  addTaskMaster(j: any) {
    let tasks = this.taskMasters[j].taskGroup;
    console.log(tasks)
    for (let i = 0; i < tasks.length; i++) {
      this.addMasterTicketTask(tasks[i].name, tasks[i].description)
    }

    setTimeout(() => this.reload(), 2000);

  }

  reload() {
    this.getTicketTaskByID(this.ticketId)
    document.getElementById("closeModalButton5")?.click()
  }


  addMasterTicketTask(name: any, description: any) {

    let tagUserIds = [];
    for (let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }

    let body = {
      "ticketId": this.ticketId,
      "taskList": [
        {
          "version": 0,
          "isActive": true,
          "description": String(description),
          "taskRegType": "",
          "taskRegId": "",
          "taskSINumber": 0,
          "taskListingNumber": 0,
          "assignedTo": String(this.Taskform.get('assignedTo').value),
          "taskExpStartDate": new Date(this.Taskform.get('taskExpStartDate').value).getTime(),
          "taskExpEndDate": new Date(this.Taskform.get('taskExpEndDate').value).getTime(),
          "taskActStartDate": 0,
          "taskActEndDate": 0,
          "taskExpDuration": 0,
          "taskActDuration": 0,
          "status": [
            {
              "note": "",
              "taskStatus": "NEW",
              "updatedDate": 0
            }
          ],
          "completedPercentage": 0,
          "notes": "",
          "audio": this.audios,
          "video": this.videos,
          "image": this.images,
          "tagUserIds": tagUserIds,
          "name": String(name),
          "cid": this.cid
        }
      ]
    }
    console.log(body)
    this.generic_service.addTicketTask(body).subscribe(
      (response: any) => {
        console.log(response)
        // this.getAllTicketTask()
        // this.toastr.success(response.message);
        // this.cancelModel()
        // this.clearForm()
      }, (err: any) => {
        console.log(err)
        this.toastr.error(err.errors[0].description);

      }
    )
  }

  ticketStatusDropdown() {
    console.log(this.ticketStatus)
    if (this.ticketStatus == "COMPLETED") {
      this.note = "Ticket Completed by" + " " + sessionStorage.getItem('userName')
    }
    if (this.ticketStatus == "CLOSED") {
      this.note = "Ticket Closed by" + " " + sessionStorage.getItem('userName')
    }

  }

  autoFill(taskName: any, taskDescription: any) {
    this.Taskform.get('name').setValue(taskName);
    this.Taskform.get('description').setValue(taskDescription);
    document.getElementById("closeModalButton67")?.click()

  }

  ticketStatusDropdownChange() {
    this.pageNumber = 0

    if (this.status == "UNASSIGNED") {
      this.getAllUnAssignedTicketTaskList(this.pageNumber, this.recordsPerPage)
    } else {
      if (this.status != "ALL") {
        this.ticketFilterByStatus(this.pageNumber, this.recordsPerPage)
      } else {
        this.getAllTicketTaskWithPagination(this.pageNumber, this.recordsPerPage)
      }
    }
  }


  // ticketByStatus(){
  //   this.pageNumber = 0
  //   if(this.status != "ALL"){
  //     this.ticketFilterByStatus(this.pageNumber,this.recordsPerPage)
  //   }else{
  //     this.getAllTicket(this.pageNumber,this.recordsPerPage)
  //   }
  // }
  ticketByStatus() {
    if (
      this.filterDateChecked == true ||
      this.customerPhoneNoChecked == true ||
      this.filterByTicketIdChecked == true ||
      this.filterByTechnicianChecked == true ||
      this.filterByticketPriorityChecked == true ||
      this.filterByticketClosedAndDatesChecked == true ||
      this.filterByticketCompletedAndDatesChecked == true ||
      this.filterByServiceTypeChecked == true) {
      console.log('filter')

      if (this.filterDateChecked) {
        this.ticketFilterByCreatedBetweenDates(this.pageNumber, this.recordsPerPage, this.startDate, this.endDate)
      }
      if (this.customerPhoneNoChecked) {
        this.getAllTicketsByCustomerPhoneNo(this.customerPhoneNo, this.pageNumber, this.recordsPerPage)
      }
      if (this.filterByTicketIdChecked) {
        this.getTicketTaskByTicketId(this.filterByTicketId)
      }
      if (this.filterByTechnicianChecked) {
        this.getAllByAssignedTo(this.filterByTechnician, this.pageNumber, this.recordsPerPage)
      }
      if (this.filterByticketPriorityChecked) {
        this.getAllByTicketPriority(this.filterByticketPriority, this.pageNumber, this.recordsPerPage)
      }

      if (this.filterByticketClosedAndDatesChecked) {
        this.filterByTicketStatusAndBetweenDates(this.status, this.pageNumber, this.recordsPerPage)
      }

      if (this.filterByticketCompletedAndDatesChecked) {
        this.filterByTicketStatusAndBetweenDates(this.status, this.pageNumber, this.recordsPerPage)
      }
      if (this.filterStatusAndDateChecked) {
        this.getAllTicketsByStatusAndBetweenUpdatedDates(this.filterStatusDate, this.pageNumber, this.recordsPerPage, this.statusStartDate, this.statusEndDate)
      }

      if (this.filterByServiceTypeChecked) {
        this.filterByCustomerType(this.filterByServiceType, this.pageNumber, this.recordsPerPage)
      }
    } else {
      if (this.status == "UNASSIGNED") {
        this.getAllUnAssignedTicketTaskList(this.pageNumber, this.recordsPerPage)
      } else {
        if (this.status != "ALL") {
          this.ticketFilterByStatus(this.pageNumber, this.recordsPerPage)
        } else {
          this.getAllTicket(this.pageNumber, this.recordsPerPage)
        }
      }
    }
  }



  getAllTicket(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.getcontroller(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList
        let count = 0
        // for(var i=0; i<response.response.length; i++) {
        //   if(response.response[i].ticketStatus == 'NEW'){
        //     count++;
        //     console.log(response.response[i].ticketStatus)
        //   }
        // }
        // this.newTicketCount = count
        console.log("ok")
        console.log(response)
        this.isLoading = false

      }
    )
  }

  // getAllUnAssignedTicketTaskList(){
  //   this.generic_service.getAllUnAssignedTicketTaskList().subscribe(
  //     (response:any)=>{
  //       this.totalRecords = response.response.totalRecords
  //       this.data = response.response.ticketList
  //       console.log(response)
  //     }
  //   )
  // }

  taskPopUpClose() {
    document.getElementById("closeModalButton3")?.click()
  }

  assignTaskId: any = ""
  userId: any = ""
  taskStatus: any = ""
  assignName: any = ""

  taskSelected(taskId: any, taskStatus: any) {
    this.assignTaskId = taskId;
    this.taskStatus = taskStatus;
  }

  getAllUnAssignedTicketTaskList(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.getAllUnAssignedTicketTaskList(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList
        this.isLoading = false

      }
    )
  }

  getAllTicketTaskWithPagination(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.getAllTicketTaskWithPagination(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList
        this.isLoading = false

      }
    )
  }


  taskAssignToUser() {
    if (this.userId == "") {
      return;
    }

    for (var i = 0; i < this.usersWithoutCustomers.length; i++) {
      if (this.usersWithoutCustomers[i].userId == Number(this.userId)) {
        this.assignName = this.usersWithoutCustomers[i].userName
      }
    }
    let note = "";
    if (this.taskStatus == "REASSIGNED") {
      note = "Task REASSIGNED to " + this.assignName;
    } else {
      note = "Task ASSIGNED to " + this.assignName;
    }
    let body = {
      "taskId": Number(this.assignTaskId),
      "userId": Number(this.userId),
      "taskStatusDTO": {
        "note": String(note),
        "taskStatus": String(this.taskStatus),
        "updatedDate": 0
      }
    }
    console.log(body)
    this.generic_service.taskAssignToUser(body).subscribe(
      (response: any) => {
        console.log(response);
        this.getTicketTaskByID(this.ticketId)
        document.getElementById("closeTaskAssign")?.click()
        // this.getTicketcontroller()
        // this.getSingleTask(taskId);
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  filterClicked(filter: any) {
    this.filterDateChecked = false
    this.customerPhoneNoChecked = false
    this.filterByTicketIdChecked = false
    this.filterByTechnicianChecked = false
    this.filterByticketPriorityChecked = false
    this.filterByticketCompletedAndDatesChecked = false
    this.filterByticketClosedAndDatesChecked = false
    this.filterStatusAndDateChecked = false
    this.filterByServiceTypeChecked = false

    if (filter == "filterDateChecked") {
      this.filterDateChecked = true
    }
    if (filter == "customerPhoneNoChecked") {
      this.customerPhoneNoChecked = true
    }
    if (filter == "filterByTicketIdChecked") {
      this.filterByTicketIdChecked = true
    }
    if (filter == "filterByTechnicianChecked") {
      this.filterByTechnicianChecked = true
    }

    if (filter == "filterByticketPriorityChecked") {
      this.filterByticketPriorityChecked = true
    }

    if (filter == "filterByticketClosedAndDatesChecked") {
      this.filterByticketClosedAndDatesChecked = true
      // this.status = "CLOSED"
    }

    if (filter == "filterByticketCompletedAndDatesChecked") {
      this.filterByticketCompletedAndDatesChecked = true
      // this.status = "COMPLETED"
    }

    if (filter == "filterStatusAndDateChecked") {
      this.filterStatusAndDateChecked = true
      // this.status = "COMPLETED"
    }

    if (filter == "filterByServiceTypeChecked") {
      this.filterByServiceTypeChecked = true
      // this.status = "COMPLETED"
    }
  }


  applyFilter() {
    this.pageNumber = 0
    this.pageNumber1 = 0
    this.downloadData = []
    if (this.filterDateChecked) {
      this.ticketFilterByCreatedBetweenDates(this.pageNumber, this.recordsPerPage, this.startDate, this.endDate)
      setTimeout(() => {
        this.ticketFilterByCreatedBetweenDatesAllRecords(this.pageNumber, this.totalRecords, this.startDate, this.endDate)
      }, 10000);
    }
    if (this.customerPhoneNoChecked) {
      this.getAllTicketsByCustomerPhoneNo(this.customerPhoneNo, this.pageNumber, this.recordsPerPage)
      setTimeout(() => {
        this.getAllTicketsByCustomerPhoneNoAllRecords(this.customerPhoneNo, this.pageNumber, this.totalRecords)
      }, 10000);
    }
    if (this.filterByTicketIdChecked) {
      this.getTicketTaskByTicketId(this.filterByTicketId)
      // this.getTicketTaskByTicketIdAllRecords(this.filterByTicketId)
    }
    if (this.filterByTechnicianChecked) {
      this.getAllByAssignedTo(this.filterByTechnician, this.pageNumber, this.recordsPerPage)
      setTimeout(() => {
        this.getAllByAssignedToAllRecords(this.filterByTechnician, this.pageNumber, this.totalRecords)
      }, 10000);
    }
    if (this.filterByticketPriorityChecked) {
      this.getAllByTicketPriority(this.filterByticketPriority, this.pageNumber, this.recordsPerPage)
      setTimeout(() => {
        this.getAllByTicketPriorityAllRecords(this.filterByticketPriority, this.pageNumber, this.totalRecords)
      }, 10000);
    }

    if (this.filterByticketClosedAndDatesChecked) {
      this.filterByTicketStatusAndBetweenDates(this.status, this.pageNumber, this.recordsPerPage)
      setTimeout(() => {
        this.filterByTicketStatusAndBetweenDatesAllRecords(this.status, this.pageNumber, this.totalRecords)
      }, 10000);
    }

    if (this.filterByticketCompletedAndDatesChecked) {
      this.filterByTicketStatusAndBetweenDates(this.status, this.pageNumber, this.recordsPerPage)
      setTimeout(() => {
        this.filterByTicketStatusAndBetweenDatesAllRecords(this.status, this.pageNumber, this.totalRecords)
      }, 10000);
    }
    if (this.filterStatusAndDateChecked) {
      this.getAllTicketsByStatusAndBetweenUpdatedDates(this.filterStatusDate, this.pageNumber, this.recordsPerPage, this.statusStartDate, this.statusEndDate)
      setTimeout(() => {
        this.getAllTicketsByStatusAndBetweenUpdatedDatesAllRecords(this.filterStatusDate, this.pageNumber, this.totalRecords, this.statusStartDate, this.statusEndDate)
      }, 10000);
    }

    if (this.filterByServiceTypeChecked) {
      this.filterByCustomerType(this.filterByServiceType, this.pageNumber, this.recordsPerPage)
      setTimeout(() => {
        this.allFilterByCustomerType(this.filterByServiceType, this.pageNumber, 100)
      }, 10000);
    }

  }

  getAllByTicketPriority(ticketPriority: any, pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.getAllByTicketPriority(ticketPriority, pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.data = []
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllByTicketPriorityAllRecords(ticketPriority: any, pageNumber: any, recordsPerPage: any) {
    this.generic_service.getAllByTicketPriority(ticketPriority, pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.downloadData = response.response.ticketTaskResponseList
      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  getAllTicketsByCustomerPhoneNo(customerPhNo: any, pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.getAllTicketsByCustomerPhoneNo(customerPhNo, pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.data = []
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllTicketsByCustomerPhoneNoAllRecords(customerPhNo: any, pageNumber: any, recordsPerPage: any) {
    this.generic_service.getAllTicketsByCustomerPhoneNo(customerPhNo, pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.downloadData = response.response.ticketTaskResponseList
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllByAssignedTo(assignedToId: any, pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.getAllByAssignedTo(assignedToId, pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.data = []
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  filterByCustomerType(filterByServiceType: any, pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.filterByCustomerType(filterByServiceType, pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.data = []
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  allFilterByCustomerType(filterByServiceType: any, pageNumber: any, recordsPerPage: any) {
    this.generic_service.filterByCustomerType(filterByServiceType, pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.downloadData = response.response.ticketTaskResponseList
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllByAssignedToAllRecords(assignedToId: any, pageNumber: any, recordsPerPage: any) {
    this.generic_service.getAllByAssignedTo(assignedToId, pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)

        this.downloadData = response.response.ticketTaskResponseList
      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  refreshTickets() {
    this.status = "OPEN"
    this.pageNumber = 0
    this.ticketFilterByStatus(this.pageNumber, this.recordsPerPage)
  }

  ticketFilterByStatus(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.ticketFilterByStatus(pageNumber, recordsPerPage, this.status).subscribe(
      (response: any) => {
        console.log(response)

        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList
        this.isLoading = false


      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  filterByTicketStatusAndBetweenDates(status: any, pageNumber: any, recordsPerPage: any) {
    this.filterStartDate = new Date()
    let endDate: any = new Date(this.endDate).getTime()
    let startDate = new Date(this.startDate).getTime()
    let filterStatus = status

    if (this.filterByticketClosedAndDatesChecked) {
      this.filterStartDate.setDate(this.filterStartDate.getDate() - Number(this.filterByticketClosedAndDates));
      startDate = new Date(this.filterStartDate).getTime()
      endDate = new Date().getTime()
      filterStatus = "CLOSED"
    }

    if (this.filterByticketCompletedAndDatesChecked) {
      this.filterStartDate.setDate(this.filterStartDate.getDate() - Number(this.filterByticketCompletedAndDates));
      startDate = new Date(this.filterStartDate).getTime()
      endDate = new Date().getTime()
      filterStatus = "COMPLETED"
    }

    this.isLoading = true


    this.generic_service.filterByTicketStatusAndBetweenDates(filterStatus, pageNumber, recordsPerPage, startDate, endDate).subscribe(
      (response: any) => {
        console.log(response)
        this.data = []
        this.totalRecords = response.response.totalRecords

        this.data = response.response.ticketTaskResponseList
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  filterByTicketStatusAndBetweenDatesAllRecords(status: any, pageNumber: any, recordsPerPage: any) {
    this.filterStartDate = new Date()
    let endDate: any = new Date(this.endDate).getTime()
    let startDate = new Date(this.startDate).getTime()
    let filterStatus = status

    if (this.filterByticketClosedAndDatesChecked) {
      this.filterStartDate.setDate(this.filterStartDate.getDate() - Number(this.filterByticketClosedAndDates));
      startDate = new Date(this.filterStartDate).getTime()
      endDate = new Date().getTime()
      filterStatus = "CLOSED"
    }

    if (this.filterByticketCompletedAndDatesChecked) {
      this.filterStartDate.setDate(this.filterStartDate.getDate() - Number(this.filterByticketCompletedAndDates));
      startDate = new Date(this.filterStartDate).getTime()
      endDate = new Date().getTime()
      filterStatus = "COMPLETED"
    }

    this.generic_service.filterByTicketStatusAndBetweenDates(filterStatus, pageNumber, recordsPerPage, startDate, endDate).subscribe(
      (response: any) => {
        console.log(response)

        this.downloadData = response.response.ticketTaskResponseList
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getTicketTaskByTicketId(ticketId: any) {
    this.isLoading = true

    this.generic_service.getTicketTaskByTicketId(ticketId).subscribe(
      (response: any) => {
        console.log(response)
        this.data = []
        this.totalRecords = 1
        this.data.push(response.response)
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllTicketsByStatusAndBetweenUpdatedDates(status: any, pageNumber: any, recordsPerPage: any, startDate: any, endDate: any) {

    startDate = new Date(startDate).getTime()
    endDate = new Date(endDate).getTime()
    this.isLoading = true

    this.generic_service.getAllTicketsByStatusAndBetweenUpdatedDates(status, pageNumber, recordsPerPage, startDate, endDate).subscribe(
      (response: any) => {
        console.log(response)
        this.data = []
        this.totalRecords = response.response.totalRecords

        this.data = response.response.ticketTaskResponseList
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllTicketsByStatusAndBetweenUpdatedDatesAllRecords(status: any, pageNumber: any, recordsPerPage: any, startDate: any, endDate: any) {

    startDate = new Date(startDate).getTime()
    endDate = new Date(endDate).getTime()
    this.generic_service.getAllTicketsByStatusAndBetweenUpdatedDates(status, pageNumber, recordsPerPage, startDate, endDate).subscribe(
      (response: any) => {
        console.log(response)

        this.downloadData = response.response.ticketTaskResponseList
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  ticketFilterByCreatedBetweenDates(pageNumber: any, recordsPerPage: any, startDate: any, endDate: any) {
    startDate = new Date(startDate).getTime()
    endDate = new Date(endDate).getTime()
    this.isLoading = true

    this.generic_service.ticketFilterByCreatedBetweenDates(pageNumber, recordsPerPage, startDate, endDate).subscribe(
      (response: any) => {
        console.log(response)
        this.data = []
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  ticketFilterByCreatedBetweenDatesAllRecords(pageNumber: any, recordsPerPage: any, startDate: any, endDate: any) {
    startDate = new Date(startDate).getTime()
    endDate = new Date(endDate).getTime()
    this.generic_service.ticketFilterByCreatedBetweenDates(pageNumber, recordsPerPage, startDate, endDate).subscribe(
      (response: any) => {
        console.log(response)
        this.downloadData = response.response.ticketTaskResponseList
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  resetFilter() {
    this.filterDateChecked = false
    this.customerPhoneNoChecked = false
    this.filterByTicketIdChecked = false
    this.filterByTechnicianChecked = false
    this.filterByticketPriorityChecked = false
    this.filterByticketClosedAndDatesChecked = false
    this.filterByticketCompletedAndDatesChecked = false
    this.filterByServiceTypeChecked = false
    this.startDate = ""
    this.endDate = ""
    this.customerPhoneNo = ""
    this.filterByTicketId = ""
    this.filterByTechnician = ""
    this.filterByticketPriority = ""
    this.filterByServiceType = ""

    this.status = "OPEN"
    this.ticketByStatus()
  }



  downLoad() {

    this.excelData = []

    for (let i = 0; i < this.downloadData.length; i++) {

      let obj: any = {
        "createdBy": this.downloadData[i].ticket.createdBy,
        "createdByUserName": this.downloadData[i].ticket.createdByUserName,
        "ticketId": this.downloadData[i].ticket.ticketId,
        "priorityNotification": this.downloadData[i].ticket.priorityNotification,
        "latestTicketStatus": this.downloadData[i].ticket.latestTicketStatus,
        "heading": this.downloadData[i].ticket.heading,
        "raisedBy": this.downloadData[i].ticket.raisedBy,
        "remarks": this.downloadData[i].ticket.remarks,
        "assignedToUserName": this.downloadData[i].ticket.assignedToUserName,
        "assignedToPhoneNo": this.downloadData[i].ticket.assignedToPhoneNo,
        "ticketExpStartDate": formatDate(this.downloadData[i].ticket.ticketExpStartDate, 'yyyy-MM-dd', 'en-US'),
        "ticketExpEndDate": formatDate(this.downloadData[i].ticket.ticketExpEndDate, 'yyyy-MM-dd', 'en-US'),
        "tpriority": this.downloadData[i].ticket.tpriority,
        "assignedOn": formatDate(this.downloadData[i].ticket.assignedOn, 'yyyy-MM-dd', 'en-US'),
        "ticketNo": this.downloadData[i].ticket.ticketNo,
      }
      this.excelData.push(obj)
    }

    let keys = Object.keys(this.excelData[0])
    console.log(keys)
    console.log(this.excelData)
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      showTitle: false,
      useBom: false,
      headers: keys
    };

    new ngxCsv(this.excelData, 'Report', options);
  }

  priorityToggle() {
    this.priority_dropdown_toggle = !this.priority_dropdown_toggle
  }

  updateTicketPriority(ticketId: any, ticketPriority: any) {
    this.generic_service.updateTicketPriority(ticketId, ticketPriority).subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        this.getTicketTaskByID(ticketId)
        this.priorityToggle()
        console.log(response)
      },
      (error: any) => {
        console.log(error)
        this.priorityToggle()
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  upDateTicketDetailsToggle() {
    this.ticketDetails_toggle = !this.ticketDetails_toggle
  }

  updateTicketDetails() {

    if (this.updateDetails == '') {
      this.toastr.error('detail required')
      return
    }

    const body = {
      "details": this.updateDetails,
      "ticketId": this.ticketId,
      "cid": Number(this.cid)
    }

    this.generic_service.updateTicketDetails(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        this.getTicketTaskByID(this.ticketId)
        this.upDateTicketDetailsToggle()
        console.log(response)
      },
      (error: any) => {
        console.log(error)
        this.upDateTicketDetailsToggle()
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }


  updateTaskDetailsToggle(i: any) {
    this.TicketTaskdata[i].edit = !this.TicketTaskdata[i].edit
    // this.taskDetails_toggle = !this.taskDetails_toggle
  }

  updateTaskDescription(i: any, taskId: any) {

    if (this.updateDetails == '') {
      this.toastr.error('description required')
      return
    }

    const body = {
      "description": this.TicketTaskdata[i].eDescription,
      "taskId": Number(taskId),
      "cid": Number(this.cid)
    }

    this.generic_service.updateTaskDescription(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        // this.getTicketTaskByID(this.ticketId)
        // this.updateTaskDetailsToggle()
        this.getTicketTaskByID(this.ticketId)

        console.log(response)
      },
      (error: any) => {
        console.log(error)
        // this.updateTaskDetailsToggle()
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  selectLargeImage(largeImage: any) {
    this.largeImage = largeImage
  }


  addcontroller() {
    this.formSubmit = true;
    if (!this.form.valid) {
      console.log(this.form.value)
      return
    }
    let tagUserIds = [];
    for (let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }


    let keyValueList: any = []

    for (let i = 0; i < this.keyValueList.length; i++) {
      keyValueList.push(
        {
          "key": this.keyValueList[i].key,
          "value": this.keyValueList[i].value
        }
      )
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "typeId": Number(this.form.get('typeId').value),
      "ticketSubTypeId": 0,
      "parentTicketId": 0,
      "priorityId": 0,
      "ticketStatus": [
        {
          "note": "Ticket Created by" + " " + sessionStorage.getItem('userName'),
          "ticketStatus": "OPEN"
        }
      ],
      "heading": String(this.form.get('heading').value),
      "details": String(this.form.get('details').value),
      "resolution": "",
      "source": "Admin",
      "raisedBy": "",
      "remarks": "",
      "assignedTo": "",
      "assignedToUserName": String(this.form.get('assignedToUserName').value),
      "startTime": 0,
      "endTime": 0,
      "customerID": String(this.form.get('customerID').value),
      "customerName": String(this.form.get('customerName').value),
      "customerNotes": "",
      "technicianNotes": "",
      "customerPhNo": String(this.form.get('customerPhNo').value),
      "customerAddress": "",
      "startNotes": "",
      "endNotes": "",
      "pendingNotes": "",
      "customerType": String(this.form.get('customerType').value),
      "latestTicketStatus": "OPEN",
      "assignedBy": "",
      "latitude": "",
      "startLatitude": "",
      "startLongitude": "",
      "endLatitude": "",
      "endLongitude": "",
      "agentId": 0,
      "audio": [],
      "video": [],
      "image": this.images,
      "tagUserIds": tagUserIds,
      "assignedOn": 0,
      "serviceQuality": 0,
      "keyValueList": keyValueList,
      "longitude": "",
      "ticketNo": 0,
      "cid": this.cid
    }


    console.log(body)
    this.generic_service.addcontroller(body).subscribe(
      (response: any) => {
        console.log(response)
        let taskId = response.response.id + '_1'
        // this.getSingleTask(taskId)
        this.cancelModel()
        this.toastr.success(response.message);
        this.tagUsersselectedItems = []
        this.formSubmit = false;
        this.form.reset()
      }, (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);

      }
    )
  }

  getParamByType() {
    this.generic_service.getParamByType('TICKETPARAM').subscribe(
      (response: any) => {
        console.log(response);
        this.ProductParams = response.response;
        console.log(this.ProductParams);

        for (let i = 0; i < this.ProductParams.length; i++) {
          this.keyValueList.push(
            {
              "key": this.ProductParams[i].name,
              "value": "",
              "possibleValue": this.ProductParams[i].possibleValue
            }
          )
        }
        console.log(this.keyValueList);

      }
    )
  }

  onChange(event: any) {
    this.file = event.target.files[0];
    this.onUpload()
  }

  onUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.images.push(event.response)
    });
  }


  addNoteImage() {
    document.getElementById("add-note-image")?.click()
  }

  onChangeAddNoteImage(event: any) {
    this.file = event.target.files[0];
    this.uploadAddNoteImage()
  }

  removeNoteImage() {
    this.NoteImage = ""
  }

  uploadAddNoteImage() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.NoteImage = event.response
    });
  }


  getCustomerParams() {
    this.generic_service.predefinedParameter('CUSTREG').subscribe(
      (response: any) => {
        console.log(response)
        for (let i = 0; i < response.response.length; i++) {
          this.paramData.push(
            {
              name: response.response[i].name,
              possibleValue: response.response[i].possibleValue,
              value: ""
            }
          )
        }
        console.log(this.paramData)
      },
      (err: any) => {
        console.log(err)
      }
    )
  }



  addCustomer() {
    let customerParamEntityList: any = []

    for (let i = 0; i < this.paramData.length; i++) {
      customerParamEntityList.push(
        {
          "key": this.paramData[i].name,
          "value": this.paramData[i].value
        }
      )
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.customerForm.get('description').value),
      "name": String(this.customerForm.get('name').value),
      "address": String(this.customerForm.get('address').value),
      "serviceName": String(this.customerForm.get('serviceName').value),

      "mobileNo1": String(this.customerForm.get('mobileNo1').value),
      "mobileNo2": String(this.customerForm.get('mobileNo2').value),
      "emailId": String(this.customerForm.get('emailId').value),
      "customerParamEntityList": customerParamEntityList,
      "image": this.url1,
      "documents": this.documents,
      "cid": this.cid,

      "lmoDataId": 0,
      "geoAddress": [
        {
          "slNo": "",
          "name": "",
          "phone1": "",
          "phone2": "",
          "email": "",
          "latitude": String(this.latitude),
          "longitude": String(this.longitude),
          "address": "",
          "postCode": "",
          "isDefault": true,
          "type": "",
          "state": "",
          "landmark": "",
          "city": "",
          "town": "",
          "district": ""
        }
      ],
      "customerType": "",
      "belongsTo": "",
      "password": "",

      "interestedProducts": [
        {
          "id": "",
          "name": "",
          "uom": "",
          "price": "",
          "keyValuePair": [
            {
              "key": "",
              "value": ""
            }
          ]
        }
      ],
      "status": [
        {
          "customerRegistrationStatus": "REQUESTED",
          "updatedDate": 0
        }
      ],
      "latestStatus": "REQUESTED"
    }

    console.log(body)
    this.generic_service.addCustomerInfo(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success(response.message)
        this.cancelModel()
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.message)
      }
    )
  }

  getAllTicketsByCustomerPhoneNo1(customerPhNo: any, pageNumber: any, recordsPerPage: any) {

    this.generic_service.getAllTicketsByCustomerPhoneNo(customerPhNo, pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.prevTicketsList = response.response.ticketTaskResponseList

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  imageView(img: any) {
    this.noteImageView = img
  }



  addTicketImageBtn() {
    document.getElementById("add-TicketImage-btn")?.click()
  }

  onTicketChange(event: any) {
    this.file = event.target.files[0];
    this.onTicketUpload()
  }

  onTicketUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.images.push(event.response)
      this.updateTicketPicture()
    });
  }

  updateTicketPicture() {
    let body = {
      "ticketId": this.TicketData[0].ticketId,
      "cid": Number(this.cid),
      "images": this.images
    }

    this.generic_service.updateTicketPicture(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success("Successfully Updated");
        this.getSingleTicket(this.ticketId)

        this.images = []
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

}
